import { Link } from '@tanstack/react-router'

import { EXTERNAL_URLS } from '@/lib/constants/url'
import { cn } from '@/lib/utils'

export const IndependentPageTopBar = () => {
  return (
    <div className={cn('flex items-center', 'h-[70px]')}>
      <div className={cn('pl-[30px]')}>
        <Link to="/">
          <img src={EXTERNAL_URLS.lawfullyProFullLogo} alt="Lawfully Pro Logo" />
        </Link>
      </div>
    </div>
  )
}
